/* ==========================================================================
 * bs-winkelwagen.js - palletblok en overzicht op de winkelwagenpagina
 * --------------------------------------------------------------------------
 * Hoort bij sections/bs-winkelwagen-pallet.liquid, main-cart-items.liquid en
 * main-cart-footer.liquid. Refresh doet het echte werk (aantallen wijzigen,
 * verwijderen, secties opnieuw tekenen via cart.js); dit bestand leest daarna
 * wat er getekend is en vult het palletblok en het overzicht aan.
 *
 * GELD: hier wordt geen eigen rekenregel gebruikt.
 *   - pallets en percentage: BBKern.palletStand
 *   - rollen per diameter:   BBWinkel.rollenPerDiameter (de pure kern van
 *                            BBWinkel.rollenInWinkelwagen; die gebruiken we
 *                            als de winkelwagen niet op de pagina staat)
 *   - kortingsbedrag:        BBKern.geschatteKortingCenten, ALLEEN als
 *                            settings.bs_palletkorting_actief aan staat en
 *                            Shopify zelf nog geen korting in de wagen heeft.
 *                            Heeft Shopify wel een korting, dan staat die in
 *                            de Liquid en telt dat bedrag.
 *   - bedragen en btw:       BSBtw.prijsHtml / BSBtw.exclCenten
 * ========================================================================== */
(function (global) {
  'use strict';

  var doc = global.document;

  /* ---------- lezen ---------- */

  function leesJson(sel) {
    var lijst = doc.querySelectorAll(sel);
    var el = lijst.length ? lijst[lijst.length - 1] : null;
    if (!el) { return null; }
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function wagenVanPagina() { return leesJson('#main-cart-footer [data-bs-ww-cart]'); }

  /* ---------- opmaak ---------- */

  /* Een palletgetal op twee decimalen, half naar boven. De kleine marge vangt
     1,225 op dat als 1,2249999 uit de deling komt. */
  function tweeDec(x) { return Math.round((Number(x) + 0.000001) * 100) / 100; }

  function palletWoord(n) { return n >= 2 ? 'pallets' : 'pallet'; }

  function getal(n) {
    return (global.BBKern && global.BBKern.getal) ? global.BBKern.getal(n, 2) : String(n).replace('.', ',');
  }

  function rollenWoord(n) { return n === 1 ? '1 rol' : n + ' rollen'; }

  function prijs(centen, maat) {
    return global.BSBtw ? global.BSBtw.prijsHtml(centen, { maat: maat || 'klein' }) : '';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- de berekening (puur, zonder DOM, los te toetsen) ---------- */

  /**
   * @param {object} G      BBWinkel.leesGegevens(...): { producten, pallet, treden }
   * @param {object} wagen  { item_count, items:[{id,quantity}], items_subtotal_price,
   *                          total_price, total_discount, kortingen:[{titel,centen}] }
   * @param {object} opties { kortingActief, verzendCenten, gratisVanafCenten }
   */
  function bereken(G, wagen, opties) {
    var K = global.BBKern;
    var uit = { leeg: !wagen || !wagen.item_count, pallet: null, overzicht: null };
    if (uit.leeg || !G || !K) { return uit; }

    var rollen = global.BBWinkel.rollenPerDiameter(G.producten, wagen);
    var sleutels = Object.keys(G.pallet || {}).filter(function (d) { return G.pallet[d] > 0; });
    var heeftRollen = Object.keys(rollen).some(function (d) { return rollen[d] > 0; });

    var treden = G.treden || { een: 5, twee: 10 };
    var stand = null;
    if (sleutels.length && heeftRollen) {
      var G2 = { producten: G.producten, pallet: G.pallet, treden: treden, winkelwagen: rollen };
      stand = K.palletStand(G2, Number(sleutels[0]), { rollen: 0, centen: 0 });
    }

    /* Korting die Shopify al in de wagen heeft: dat bedrag telt. */
    var shopifyPallet = 0;
    (wagen.kortingen || []).forEach(function (k) {
      if (/pallet/i.test(k.titel || '')) { shopifyPallet += Number(k.centen) || 0; }
    });

    var schatting = 0;
    if (stand && stand.percentage > 0 && opties.kortingActief && !(wagen.total_discount > 0)) {
      schatting = K.geschatteKortingCenten(wagen.items_subtotal_price, stand.percentage);
    }

    if (stand) {
      var getoond = tweeDec(stand.deel);
      /* Het getoonde getal mag nooit een trede halen die de kern (nog) niet geeft. */
      if (stand.pallets < 1 && getoond >= 1) { getoond = 0.99; }
      if (stand.pallets === 1 && getoond >= 2) { getoond = 1.99; }

      var delen = sleutels.filter(function (d) { return rollen[d] > 0; }).map(function (d) {
        var een = {}; een[d] = rollen[d];
        return { diameter: Number(d), rollen: rollen[d], perPallet: G.pallet[d], deel: K.palletDeel(G.pallet, een) };
      });
      delen.sort(function (a, b) { return a.diameter - b.diameter; });

      var doel = stand.pallets < 1 ? 1 : (stand.pallets < 2 ? 2 : null);
      uit.pallet = {
        stand: stand,
        getoond: getoond,
        delen: delen,
        treden: treden,
        doel: doel,
        nogTotDoel: doel ? tweeDec(doel - getoond) : 0,
        doelPercentage: doel === 1 ? treden.een : (doel === 2 ? treden.twee : 0),
        kortingCenten: shopifyPallet > 0 ? shopifyPallet : schatting
      };
    }

    if (schatting > 0) {
      var naKorting = wagen.total_price - schatting;
      var verzending = naKorting >= opties.gratisVanafCenten ? 0 : opties.verzendCenten;
      var totaal = naKorting + verzending;
      var excl = global.BSBtw ? global.BSBtw.exclCenten(totaal) : Math.round(totaal * 100 / 121);
      uit.overzicht = {
        percentage: stand.percentage,
        korting: schatting,
        verzending: verzending,
        totaal: totaal,
        excl: excl,
        btw: totaal - excl
      };
    }
    return uit;
  }

  /* ---------- tekenen ---------- */

  function zetHtml(root, naam, html) {
    var el = root.querySelector('[data-bs-ww="' + naam + '"]');
    if (el) { el.innerHTML = html; }
    return el;
  }

  function tekenPallet(blok, p) {
    if (!blok) { return; }
    if (!p) { blok.hidden = true; return; }
    blok.hidden = false;

    var st = p.stand;
    var n = getal(p.getoond) + ' ' + palletWoord(p.getoond);
    var titel;
    if (st.percentage > 0) {
      titel = p.kortingCenten > 0
        ? n + ', ' + st.percentage + '% palletkorting actief'
        : n + ', goed voor ' + st.percentage + '% palletkorting';
    } else {
      titel = n + ', nog geen palletkorting';
    }
    zetHtml(blok, 'titel', esc(titel));

    var badge = blok.querySelector('[data-bs-ww="badge"]');
    if (badge) {
      if (p.kortingCenten > 0) { badge.innerHTML = '&minus;&nbsp;' + prijs(p.kortingCenten, 'klein'); badge.hidden = false; }
      else { badge.hidden = true; badge.innerHTML = ''; }
    }

    /* balk: de schaal loopt van 0 tot 2 pallets */
    var spoor = '';
    var links = 0;
    p.delen.forEach(function (d, i) {
      var breed = Math.max(0, Math.min(100 - links, d.deel / 2 * 100));
      if (breed <= 0) { return; }
      spoor += '<i class="bs-ww-deel bs-ww-d' + d.diameter + (i ? ' bs-ww-deel--na' : '') + '" style="left:' + links.toFixed(2) + '%;width:' + breed.toFixed(2) + '%"></i>';
      links += breed;
    });
    zetHtml(blok, 'spoor', spoor);
    zetHtml(blok, 'merk1', '<b>1 pallet</b> &middot; ' + p.treden.een + '%');
    zetHtml(blok, 'merk2', '<b>2 pallets</b> &middot; ' + p.treden.twee + '%');
    var meter = blok.querySelector('.bs-ww-meter');
    if (meter) {
      meter.setAttribute('aria-label', getal(p.getoond) + ' van 2 pallets');
    }

    /* optelling per diameter */
    var optel = '';
    p.delen.forEach(function (d, i) {
      if (i) { optel += '<span class="bs-ww-plus" aria-hidden="true">+</span>'; }
      optel += '<span class="bs-ww-deelpil"><i class="bs-ww-stip bs-ww-d' + d.diameter + '" aria-hidden="true"></i>'
        + '&Oslash;' + d.diameter + '&nbsp;cm: ' + rollenWoord(d.rollen) + ' van ' + d.perPallet + ' <b>' + getal(tweeDec(d.deel)) + '</b></span>';
    });
    if (p.delen.length > 1) {
      optel += '<span class="bs-ww-plus" aria-hidden="true">=</span><span class="bs-ww-deelpil"><b>' + esc(n) + '</b></span>';
    }
    zetHtml(blok, 'optel', optel);

    var nog = p.doel
      ? 'Nog <b>' + getal(p.nogTotDoel) + ' ' + palletWoord(p.nogTotDoel) + '</b> tot ' + p.doelPercentage + '% korting'
      : 'Je zit op de hoogste palletkorting, <b>' + p.treden.twee + '%</b>';
    zetHtml(blok, 'nog', nog);
  }

  function tekenOverzicht(o) {
    var root = doc.getElementById('main-cart-footer');
    if (!root || !o) { return; }
    var regel = root.querySelector('[data-bs-ww="korting-regel"]');
    if (regel) {
      regel.hidden = false;
      zetHtml(regel, 'korting-titel', 'Palletkorting ' + o.percentage + '%');
      zetHtml(regel, 'korting-bedrag', '&minus;&nbsp;' + prijs(o.korting, 'klein'));
    }
    var vz = root.querySelector('[data-bs-ww="verzending"]');
    if (vz) {
      vz.classList.toggle('bs-ww-gratis', o.verzending === 0);
      vz.innerHTML = o.verzending === 0 ? 'Gratis' : prijs(o.verzending, 'klein');
    }
    zetHtml(root, 'totaal', prijs(o.totaal, 'groot'));
    zetHtml(root, 'btw', esc(global.BSBtw ? global.BSBtw.bedrag(o.btw) : ''));
    zetHtml(root, 'excl', esc(global.BSBtw ? global.BSBtw.bedrag(o.excl) : ''));
    zetHtml(root, 'incl', esc(global.BSBtw ? global.BSBtw.bedrag(o.totaal) : ''));
  }

  function tekenSub(wagen) {
    var sub = doc.querySelector('[data-bs-ww="sub"]');
    var verder = doc.querySelector('.bs-ww-verder');
    var leeg = !wagen || !wagen.item_count;
    if (verder) { verder.hidden = leeg; }
    if (!sub) { return; }
    if (leeg) { sub.hidden = true; return; }
    var a = wagen.item_count;
    var m = (wagen.items || []).length;
    sub.textContent = a + (a === 1 ? ' artikel' : ' artikelen') + ' in ' + m + (m === 1 ? ' maat' : ' maten');
    sub.hidden = false;
  }

  function opties() {
    var el = doc.querySelector('#main-cart-footer [data-bs-ww-instellingen]');
    var ds = el ? el.dataset : {};
    var blok = doc.querySelector('[data-bs-ww-pallet]');
    return {
      kortingActief: (blok && blok.getAttribute('data-korting-actief') === 'true') || ds.kortingActief === 'true',
      verzendCenten: Number(ds.verzendCenten || 499),
      gratisVanafCenten: Number(ds.gratisVanafCenten || 5000)
    };
  }

  function teken(wagen) {
    if (!global.BBWinkel || !global.BBKern) { return; }
    var G = global.BBWinkel.leesGegevens('bs-ww-rekendata');
    var w = wagen || wagenVanPagina();
    if (!w) {
      /* Geen winkelwagen op de pagina (bijvoorbeeld een aangepast sjabloon):
         haal hem op zoals de keuzehulp dat doet. */
      global.BBWinkel.winkelwagenLezen().then(function (cart) {
        teken({
          item_count: cart.item_count,
          items: (cart.items || []).map(function (i) { return { id: i.id, quantity: i.quantity }; }),
          items_subtotal_price: cart.items_subtotal_price,
          total_price: cart.total_price,
          total_discount: cart.total_discount,
          kortingen: (cart.cart_level_discount_applications || []).map(function (k) {
            return { titel: k.title, centen: k.total_allocated_amount };
          })
        });
      }).catch(function () {});
      return;
    }
    var uit = bereken(G, w, opties());
    tekenSub(w);
    tekenPallet(doc.querySelector('[data-bs-ww-pallet]'), uit.leeg ? null : uit.pallet);
    tekenOverzicht(uit.overzicht);
  }

  /* Na een wijziging die NIET via de rijen van de winkelwagen liep (bijvoorbeeld
     BBWinkel.meldWijziging): de twee secties zelf opnieuw ophalen. */
  function verversSecties() {
    var items = doc.getElementById('main-cart-items');
    var voet = doc.getElementById('main-cart-footer');
    if (!items || !voet) { teken(); return; }
    var ids = [items.dataset.id, voet.dataset.id];
    var url = global.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (secties) {
        [[items, ids[0]], [voet, ids[1]]].forEach(function (paar) {
          var html = secties[paar[1]];
          if (!html) { return; }
          var nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
          var oud = paar[0].querySelector('.js-contents');
          if (nieuw && oud) { oud.innerHTML = nieuw.innerHTML; }
        });
        var w = wagenVanPagina();
        var leeg = !w || !w.item_count;
        var ci = doc.querySelector('cart-items');
        if (ci) { ci.classList.toggle('is-empty', leeg); }
        voet.classList.toggle('is-empty', leeg);
        teken();
      })
      .catch(function () { teken(); });
  }

  function start() {
    teken();
    var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null; // eslint-disable-line no-undef
    if (typeof global.subscribe === 'function' && events && events.cartUpdate) {
      global.subscribe(events.cartUpdate, function (evt) {
        /* cart.js heeft de secties dan al vervangen, dus de wagen op de pagina is vers. */
        if (evt && evt.source === 'cart-items') { teken(); }
        else { verversSecties(); }
      });
    }
    doc.documentElement.addEventListener('cart:refresh', function () { verversSecties(); });
    doc.addEventListener('shopify:section:load', function () { teken(); });
    global.addEventListener('pageshow', function (e) { if (e.persisted) { verversSecties(); } });
  }

  global.BSWinkelwagen = { bereken: bereken, teken: teken, ververs: verversSecties, tweeDec: tweeDec };

  if (doc) {
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); }
    else { start(); }
  }
}(typeof window !== 'undefined' ? window : globalThis));
